import { render } from "./entity_risk_assessment.html?vue&type=template&id=1748a994&external"
import script from "./entity_risk_assessment.js?vue&type=script&lang=js&external"
export * from "./entity_risk_assessment.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__